export default __webpack_public_path__ + "static/media/promo-banner-freezer-lunar.476f52e3.svg";